// extracted by mini-css-extract-plugin
export var label = "_fd-2";
export var slideContainer = "_fd-0";
export var slider = "_fd-1";